<template>
  <div>
    <div class="pdfok" id="pdfok" v-if="pdfok"></div>
    <div v-if="dataover222" id="printMe" style=" width: 21cm; margin: 0 auto;">
      <div class="A4Container pageBreak_no">
        <el-card shadow="never">
          <div v-for="(item, index) in items" :key="index + 'a'">
            <h4 style="margin:0;padding-bottom: 10px;">● {{item.purchase_date}} 到货</h4>
            <div v-for="(d,idx) in item.details" :key="d.id" style="margin-bottom: 15px;">
              {{ `${idx+1}、` }}{{ d | formatText }}
            </div>
            <div>
              <span style="color: red;">合计金额：</span>
              <span v-html="summaryMoney(item)"></span>
            </div>
<!--            <el-divider v-if="index < items.length-1" />-->
            <hr v-if="index < items.length - 1" style="margin:20px -20px;border: none;height: 1px;background-color: #ccc;">
          </div>
        </el-card>
      </div>
    </div>




    <!--    <el-button v-print="'#printMe'" type="primary" style="position: fixed;top: 60px;right: 10px;z-index: 999;">-->
    <!--      打印-->
    <!--    </el-button>-->

  </div>
</template>

<script>
import Yuebao from './com_stu/yuebao'
import YuebaoKPI from './com_stu/yuebao_kpi'
import Zhoubao from './com_stu/zhoubao'

export default {
  name: 'export',
  components: {},
  data() {
    return {
      pdfok: false,
      show_dev: false,
      show_dev1: false,
      dataover222: true,
      showIdentify: false,
      printObj: {
        id: 'printMe',
        popTitle: '',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      userid: '',

      stuInfo: {},
      yuebao: [{}],
      zhoubao: [{}],
      chinaCitys: [],
      // 填入导出的pdf文件名和html元素
      pdfTitle: '试卷1',
      pdfSelector: '#printMe',
      pmid:'',
      report_type: '',
      items: [],
    }
  },
  filters: {
    formatText(item) {
      let text = item.category;
      if (item.cartons) {
        text += ` | 原箱 ${item.cartons} 箱 * ${item.carton_price} = ${item.cartons*item.carton_price}`
      }
      if (item.film_boxes) {
        text += ` | 有膜盒 ${item.film_boxes} 盒 * ${item.film_box_price} = ${item.film_boxes*item.film_box_price}`
      }
      if (item.unfilm_boxes) {
        text += ` | 无膜盒 ${item.unfilm_boxes} 盒 * ${item.unfilm_box_price} = ${item.unfilm_boxes*item.unfilm_box_price}`
      }
      if (item.trash_bags) {
        text += ` | 垃圾袋 ${item.trash_bags} 袋 * ${item.trash_bag_price} = ${item.trash_bags*item.trash_bag_price}`
      }
      if (item.bulk_packs) {
        text += ` | 散包 ${item.bulk_packs} 包 * ${item.bulk_pack_price} = ${item.bulk_packs*item.bulk_pack_price}`
      }
      return text;
    },
  },
  mounted() {
    let startDate = this.getParams('startDate')
    let endDate = this.getParams('endDate')
    let pmid = this.getParams('pmid')
    this.getDataList(startDate,endDate)
  },
  methods: {
    summaryMoney(item) {
      let text = ""
      let totalCost = 0;
      if (item.details.length > 1) {
        item.details.forEach(d => {
          text += `${d.total_cost} + `
          totalCost += d.total_cost
        })
        text = text.substring(0,text.lastIndexOf('+')) + " = "
      } else {
        totalCost = item.details.length ? item.details[0].total_cost : 0
      }

      text += `<span style="font-weight: bold"> ${totalCost}</span>`
      return text;
    },
    //过滤特殊字符, 校验所有输入域是否含有特殊符号
    stripscript(s) {
      var pattern = new RegExp('[&mdash;]')
      var rs = ''
      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '-')
      }
      return rs
    },
    findDeep(list, iid) {
      for (let i in list) {
        if (list[i].value === iid) {
          return [list[i]]
        }
        if (list[i].children != null) {
          let node = this.findDeep(list[i].children, iid);
          if (node !== undefined) {
            return node.concat(list[i])
          }
        }
      }

    },
    getDataList(startDate,endDate) {
      let _this = this
      this.$http.post(`http://api-mmcrm.aiwx.org.cn/api/get_goods_purchase`, {
        start_date: startDate,
        end_date: endDate,
        type: 2,
      }).then(res => {
        if (res.data) {
          res.data.forEach(item => {
            item.details = JSON.parse(item.details)
          })
          this.items = res.data;
        }

        this.$nextTick(() => {
          setTimeout(() => { _this.pdfok = true }, 500)
        })

      })

    },

    getParams(name) {
      let n_url = window.location.href
      n_url = n_url.replace('/#', '')
      if (n_url.indexOf('?') > 0) {
        n_url = n_url.split('?')[1]
      }
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = n_url.match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    //分割数组 arr：原数组  num：分割后每个数组里的数据条数
    util_spliceArrByN(arr, num) {
      var _arr = []
      while (arr.length) {
        _arr.push(arr.splice(0, num))
      }
      return _arr
    },
    //数组按某属性分组
    groupBy(array, f) {
      let groups = {}
      array.forEach(function (o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    }
  }
}
</script>
<style lang="less" type="text/less">
@import "/public/css/pdf_default";
</style>
